import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import n from "./navigation.module.css";
import linkedin from "../../assets/linkedin-rect.png";
import portfolio from "../../assets/fa-portfolio.png";
import SearchBar from "../search/search";
import navBack from "../../assets/menuLatBG.png";
import { useDispatch, useSelector } from "react-redux";
import { getByGenres } from "../../redux/actions/index";

export default function Sidebar({
  toggle,
  handleFilter,
  handleSort,
  currentPage,
  setCurrentPage,
}) {
  //
  const dispatch = useDispatch();
  const generos = useSelector((state) => state.genres);

  useEffect(() => {
    //
    dispatch(getByGenres());
  }, [dispatch]);

  const navigation = {
    position: "fixed",
    width: "300px",
    height: "100%",
    borderRight: "1px solid var(--border)",
    background: `url(${navBack}) no-repeat var(--black)`,
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
    justifyContent: "center",
    boxShadow: "0 0px 30px 0px rgba(0, 0, 0, 0.7)",
    overflow: "hidden",
    zIndex: "10",
    transition: "width 200ms, left 200ms, right 200ms",
  };

  const navigationActive = {
    position: "fixed",
    width: "0",
    height: "100vh",
    borderRight: "1px solid var(--border)",
    background: `url(${navBack}) no-repeat var(--black)`,
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
    justifyContent: "center",
    boxShadow: "0 0px 30px 0px rgba(0, 0, 0, 0.7)",
    overflow: "hidden",
    zIndex: "10",
    transition: "width 200ms, left 200ms, right 200ms",
  };

  return (
    <div style={toggle ? navigation : navigationActive}>
      <div className={n.alignNav}>
        <Link to="/">
          <div className={n.logo}></div>
        </Link>
        <SearchBar setCurrentPage={setCurrentPage} currentPage={currentPage} />
        <ol>
          <Link to="/form" className={n.btnNav01}>
            Create Videogame
          </Link>
          <select className={n.btnRating} onChange={(e) => handleSort(e)}>
            <option value="Rating">Rating order:</option>
            <option value="RatingAsc">Rating Ascendant</option>
            <option value="RatingDesc">Rating Descendant</option>
          </select>

          <select className={n.btnAlph} onChange={(e) => handleSort(e)}>
            <option value="Alphabetical">Alphabetical order:</option>
            <option value="A-Z">A-Z</option>
            <option value="Z-A">Z-A</option>
          </select>

          <select
            className={n.btnGenr}
            id="genre"
            onChange={(e) => handleFilter(e)}
          >
            <option value="By genre">Filter by genre:</option>
            {generos &&
              generos.map((g) => {
                return (
                  <option key={g.id} value={g.name}>
                    {g.name}
                  </option>
                );
              })}
          </select>
        </ol>
      </div>
      <div className={n.bottomNav}>
        <p>
          Created by <br></br> Lenny Snaiderman&nbsp;
        </p>
        <div className={n.iconLogo}>
          <a
            href="https://www.linkedin.com/in/lenny-snaiderman/"
            target="blank"
          >
            <img src={linkedin} alt="icon" />
          </a>
        </div>
        <div className={n.iconLogo}>
          <a href="https://bit.ly/lenny_fullstack" target="blank">
            <img src={portfolio} alt="icon" />
          </a>
        </div>
      </div>
    </div>
  );
}
